export default __webpack_public_path__ + "static/404-50f0aa5857c46a8ae299a5a93175c227.png";